// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clock-button[data-v-a032a8bc]{border:1px solid #ddd;background:transparent;color:#ddd;padding:.2em .6em .3em;height:30px;margin-left:5px;font-size:15px}.clock-button[data-v-a032a8bc]:hover{border:1px solid #fff;background:#399;color:#eff}.clock-button[data-v-a032a8bc]:disabled{border:1px solid #ddd;background:#eee;color:#5f5f5f;opacity:1!important;cursor:not-allowed!important;pointer-events:all!important}", ""]);
// Exports
module.exports = exports;
